import CustomFieldsCollapse from "components/shared/CustomFieldsCollapse";
import { termFieldsForMode } from "containers/CustomFieldsContainer/customFieldPayload";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useAppSelector } from "store/store";

import type { ITermFormValues } from "./index";
import styles from "./TermCustomFields.module.scss";

/** Custom fields of one term-form section. Hidden fields stay out of creation. */
const TermCustomFields = ({ section, mode }: { section: string; mode: "new" | "edit" }) => {
    const { formState } = useFormContext<ITermFormValues>();
    const { customFields } = useAppSelector((state) => state.customFields);
    const sectionFields = useMemo(
        () => termFieldsForMode(customFields, mode).filter((field) => field.formLocation === section),
        [customFields, mode, section],
    );

    if (!sectionFields.length) return null;

    return (
        <div className={styles["term-custom-fields"]}>
            <CustomFieldsCollapse sectionFields={sectionFields} errors={formState.errors} mode={mode} />
        </div>
    );
};

export default TermCustomFields;
